import { createClient, SupabaseClient, processLock } from '@supabase/supabase-js'

// 從環境變數讀取 Supabase 設定
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

// 驗證必要的環境變數是否已設置
if (!supabaseUrl || !supabaseAnonKey) {
  const missingVars: string[] = []
  if (!supabaseUrl) missingVars.push('VITE_SUPABASE_URL')
  if (!supabaseAnonKey) missingVars.push('VITE_SUPABASE_ANON_KEY')

  throw new Error(
    `❌ 缺少必要的環境變數: ${missingVars.join(', ')}\n\n` +
    `請在專案根目錄建立 .env 檔案，並設置以下變數:\n` +
    `VITE_SUPABASE_URL=your-supabase-project-url\n` +
    `VITE_SUPABASE_ANON_KEY=your-supabase-anon-key\n\n` +
    `如需範例，請參考 .env.example 檔案。`
  )
}

// 驗證 URL 格式
if (!supabaseUrl.startsWith('https://')) {
  console.warn('⚠️  警告: Supabase URL 應該以 https:// 開頭')
}

// 配置選項：使用共享的 storage key，讓 ppom、admin、chat 共享登入狀態
// lock 使用 @supabase/auth-js 官方 processLock（單 process in-memory lock）
// 放棄跨 tab 保護換取絕對不死鎖；之前自訂的 navigatorLockOrFallback 忽略 acquireTimeout
// 導致 fn 無限等、外層 Promise.race timeout 也救不回，造成 lock:om-auth-token 堆疊死鎖
const options = {
  auth: {
    storageKey: 'om-auth-token',
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    flowType: 'pkce',
    detectSessionInUrl: false,
    lock: processLock
  },
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, options)

export default supabase
